<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'StallionStocks',
		mixins: [ShutterCongelation],
		props: ['horse_id'],
		mounted() {
			this.setUpStallionStocksListe(this.horse_id)
		},
	}
</script>